import { render, staticRenderFns } from "./CropPuzzle.vue?vue&type=template&id=73b6f885"
import script from "./CropPuzzle.vue?vue&type=script&lang=js"
export * from "./CropPuzzle.vue?vue&type=script&lang=js"
import style0 from "./CropPuzzle.vue?vue&type=style&index=0&id=73b6f885&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports